import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FileInfo } from '../../../common/models/file';
import { FileService } from '../../../common/services/file.service';
import { NotificationForUser } from '../../../common/models/notification';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [
        MatCardModule,
        CommonModule
    ]
})
export class NotificationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  notificationFiles: FileInfo[] = [];
  @Input() notification!: NotificationForUser;
  isToggled = false;

  constructor(
    private router: Router,
    private fileService: FileService,
    public themeService: CustomizerSettingsService
  ) {
    this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {
    if (history.state && history.state.notification) {
        this.notification = history.state.notification;
        this.loadNotificationAttachments();
      } else {
        this.router.navigate(['/association/notifications']);
      }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

   loadNotificationAttachments(): void {
    if (!this.notification?.fileStorageLocation) {
      return;
    }
    this.fileService.listDocuments(this.notification.fileStorageLocation).pipe(takeUntil(this.destroy$)).subscribe({
      next: (files) => {
        this.notificationFiles = files;
      },
      error: (err) => {
        console.error('Error loading application attachments', err);
      }
    });
  }

  downloadFile(file: FileInfo): void {
      this.fileService.downloadDocument(file.link).pipe(takeUntil(this.destroy$)).subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = file.name;
          a.click();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error('Error downloading document', err);
        }
      });
    }
}